import React from "react";
import { CoreContainer } from "./style";

const ComingSoon = () => {
  return (
    <CoreContainer>
      <h4>
        <i>Coming Soon...</i>
      </h4>
    </CoreContainer>
  );
};

export default ComingSoon;
